import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldGroup } from '../../../libs/formLib';
import ButtonIcon from '../../common/ButtonIcon';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { sumBy } from 'lodash';
import { animateScroll } from 'react-scroll';
import { useScheduling } from '../../../hooks/useScheduling';
import {
  Button,
  Card,
  CardBody,
  CardText,
  Col,
  FormFeedback,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane
} from 'reactstrap';
import SummaryModal from '../Vendor/Modal';
import CredsModal from '../Vendor/CredsModal';
import BZAPIService from '../../../services/BZAPIService';
import ProductPriority from '../section/ProductPriority';
import DefaultConfigTab from '../section/DefaultConfigTab';

import TabNav from '../section/TabNav';
import TabOne from '../section/TabOne';
import ExecutionStatsTab from '../section/ExecutionStatsTab';
import RiskScore from '../section/RiskScore';
import AITab from '../section/AITab';

// constants
import SETTINGS from '../../../constants/settings';

const ConfigFormVmware = ({
  vendor,
  // settings,
  vendorLabel,
  isReadOnly,
  vendorId,
  bugsDateBack,
  setBugsDateBack,
  vendorPriorityOptions,
  vendorStatusOptions,
  vendorBugTypeOptions,
  vendorBugCategoryOptions,
  // vendorResolutionOptions,
  snIntegrationCheck,
  services,
  vendors,
  // bugs,
  priorityStats,
  // setPriorityStats,
  // bugOptions,
  // selectedBugOption,
  // setSelectedBugOption,
  snCompanySysIdOptions,
  snCompanySysIdErrors,
  organizations,
  setOrganizations,
  vendorBugTypes,
  setVendorBugTypes,
  fields,
  searchFields,
  setSearchFields,
  snCompanySysId,
  setSnCompanySysId,
  keywords,
  setKeywords,
  priorityMaps,
  setPriorityMaps,
  snPriorityOptions,
  vendorBugCategories,
  setVendorBugCategories,
  vendorStatuses,
  setVendorStatuses,
  handleFieldChange,
  setServices,
  setVendors,
  buildVendorStat,
  setPriorityStats,
  setBugs,
  isConfigured,
  isCve,
  setIsCve,
  syncOnly,
  setSyncOnly,
  bugRisk,
  setBugRisk,
  vendorRiskCategoryOptions,
  vendorRiskCategories,
  setVendorRiskCategories,
  loading,
  isServiceActive,
  setIsServiceActive,
  allRequired,
  setAllRequired,
  isUpdated,
  setIsUpdated
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  //  const [config, setConfig] = useState(null);
  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);
  const [isUpdatingCreds, setIsUpdatingCreds] = useState(false);

  const [activeTab, setActiveTab] = useState('1');
  const [modalOpen, setModalOpen] = useState(false);
  const [validated, setValidated] = useState(null);
  const [isForceRun, setIsForceRun] = useState(false);

  const [riskError, setRiskError] = useState('');

  // Use scheduling hook for state and save function
  const {
    timeUnit,
    setTimeUnit,
    timeValue,
    setTimeValue,
    schedulingMode,
    setSchedulingMode,
    schedules,
    setSchedules,
    nextRun,
    setNextRun,
    saveBugServiceFrequency
  } = useScheduling();

  async function setBugServiceFrequency() {
    await saveBugServiceFrequency(vendorId);
  }

  async function saveServiceAWSSecret() {
    const data = {
      secret: {
        username: fields.username,
        password: fields.password
      },
      vendorId: 'vmware',
      key: 'skylineAuth'
    };
    // service api secret
    return BZAPIService.createOrUpdateAWSSecret(data);
  }

  async function testCreds() {
    setIsTestingValidCredentials(true);
    const warmupData = {
      vendorId,
      functionName: 'test-creds'
    };
    const data = {
      username: fields.username,
      password: fields.password
    };
    try {
      console.log('first call');
      const result = await BZAPIService.vmWareWarmup(warmupData);
      console.log('warmup result', result);
    } catch (e) {
      console.log('failed warmup');
    }
    try {
      console.log('second call');
      const result = await BZAPIService.vendorTestCreds(vendorId, data);
      setIsTestingValidCredentials(false);
      if (result && result.completed) {
        // valid creds
        fields.refreshToken = result.refresh_token;
        setIsValidCredentials(true);
        const collectors = result?.account_collectors?.map(c => {
          return {
            label: c?.label,
            value: c?.value,
            active: 0
          };
        });
        const orgsAndCollectors = result?.account_orgs?.map(r => {
          return {
            label: r?.label,
            value: r?.value,
            active: 0,
            collectors: collectors
          };
        });
        setOrganizations(orgsAndCollectors);
        setIsAddingCredentials(false);
        setIsUpdatingCreds(true);
        toast.success('Credentials successfully validated.');
      } else {
        toast.error('Credentials failed validation.');
        setIsTestingValidCredentials(false);
      }
    } catch (e) {
      console.log(e);
      console.log('failed second call');
      toast.error('Credentials failed validation.');
      setIsTestingValidCredentials(false);
      // setIsAddingCredentials(false);
    }
  }

  async function saveConfig(serviceSecret) {
    // save client config
    const vendorPriorities = priorityMaps.map(mapping => {
      return {
        value: mapping.vendorPriority.value,
        label: mapping.vendorPriority.value,
        snPriority: mapping.snPriority.value
      };
    });

    const data = {
      secretId: serviceSecret.Name,
      bugsDateBack: bugsDateBack,
      snCompanySysId: snCompanySysId.value ? snCompanySysId.value : fields.snCompanySysId,
      snAffectedCIQuery: fields.snAffectedCIQuery,
      filterCVEs: isCve,
      accountOrgs: organizations,
      excludedKws: keywords,
      searchFields: searchFields,
      vendorPriorities,
      vendorStatuses,
      vendorBugCategories,
      vendorBugTypes,
      // vendorRiskCategories,
      type: SETTINGS.VENDOR,
      bugRiskScore: bugRisk,
      vendorRiskCategories
    };

    return BZAPIService.saveSetting(vendorId, syncOnly, data, isForceRun, isUpdatingCreds);
  }

  async function handleSave() {
    setRiskError('');
    try {
      setIsSubmitted(true);
      setIsLoading(true);
      // Validate Secrets
      if (!fields.secretId) {
        if (!fields.username || !fields.password) {
          console.log('misisng secret');
          setValidated(false);
          setIsLoading(false);
          return;
        }
      }
      // Validate filters
      if (!bugsDateBack.length || !snCompanySysId) {
        setValidated(false);
        setActiveTab('3');
        setIsLoading(false);
        return;
      }
      if (
        !priorityMaps.length ||
        !vendorBugCategories.length ||
        !vendorBugTypes.length ||
        !organizations.length ||
        !vendorRiskCategories.length
      ) {
        setValidated(false);
        setActiveTab('4');
        setIsLoading(false);
        return;
      }

      // Validate Risk Score
      const activeRisk = bugRisk.filter(y => {
        return y.active;
      });
      const activeSum = sumBy(activeRisk, risk => {
        return risk.value;
      });

      if (activeSum < 100 && activeSum > 1) {
        console.log('Bug risk share is less than 100');
        setValidated(false);
        setActiveTab('5');
        setIsLoading(false);
        setRiskError('Bug risk share total must be 100');
        return;
      }

      let serviceSecret;

      if (fields.password && fields.username) {
        // Updated secrets
        serviceSecret = await saveServiceAWSSecret();
      } else {
        // use existing secrets
        serviceSecret = { Name: fields.secretId };
      }
      // console.log('serviceSecret', serviceSecret);
      if (!serviceSecret || !serviceSecret.Name) {
        setIsLoading(false);
        setValidated(false);
        throw Error('Missing Secret');
      }
      // validate priority maps
      let validPriorities = true;
      priorityMaps.map(item => {
        if (!item.vendorPriority || !item.snPriority) validPriorities = false;
        return item;
      });
      if (!validPriorities) {
        console.log('Invalid priorities');
        setValidated(false);
        setIsLoading(false);
        return false;
      }

      await saveConfig(serviceSecret);
      // set updated secretId

      fields.secretId = serviceSecret.Name;
      setBugServiceFrequency();
      setIsLoading(false);
      setIsSubmitted(false);
      setModalOpen(false);
      setIsForceRun(false);
      setIsUpdatingCreds(false);
      setActiveTab('1');
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
  }

  const handleOrgsChange = (org, idx) => {
    const num = org.active === 1 ? 0 : 1;
    const prevState = [...organizations];
    prevState[idx] = { ...prevState[idx], active: num };
    console.log('new state', prevState);
    setOrganizations(prevState);
  };

  const handleCollectorsChange = (org, orgIdx, colIdx) => {
    const prevOrgs = [...organizations];
    const collectors = [...org.collectors];

    const num = prevOrgs[orgIdx]?.collectors[colIdx]?.active === 1 ? 0 : 1;

    collectors[colIdx] = { ...collectors[colIdx], active: num };
    prevOrgs[orgIdx] = { ...prevOrgs[orgIdx], collectors };

    console.log('state update', prevOrgs);

    setOrganizations(prevOrgs);
  };

  function handleValidationError() {
    setModalOpen(!modalOpen);
    animateScroll.scrollToTop();
  }

  useEffect(() => {
    setIsUpdated(true);
    if (
      bugsDateBack?.length &&
      snCompanySysId?.value &&
      priorityMaps?.length &&
      !priorityMaps.some(mapping => !mapping.snPriority || !mapping.vendorPriority) &&
      vendorRiskCategories.length &&
      organizations.length &&
      vendorBugTypes.length &&
      vendorBugCategories.length &&
      (fields.secretId || (fields.password && fields.username))
    ) {
      setAllRequired(true);
    } else {
      setAllRequired(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fields,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    bugsDateBack,
    priorityStats,
    priorityMaps,
    keywords,
    searchFields,
    snCompanySysId,
    vendorRiskCategories,
    isCve,
    organizations,
    vendorBugTypes,
    vendorBugCategories
  ]);

  return (
    <>
      <TabNav
        vendorId={vendorId}
        credentials={true}
        activeTab={activeTab}
        snIntegrationCheck={snIntegrationCheck}
        setActiveTab={setActiveTab}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setServices={setServices}
        setVendors={setVendors}
        buildVendorStat={buildVendorStat}
        setPriorityStats={setPriorityStats}
        setBugs={setBugs}
        isConfigured={isConfigured}
        hasBugRisk={true}
        loading={loading}
        aiSupported={vendor?.aiSupported}
      />
      <TabContent>
        <TabOne
          vendorId={vendorId}
          vendorLabel={vendorLabel}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          snIntegrationCheck={snIntegrationCheck}
          services={services}
          vendors={vendors}
          priorityStats={priorityStats}
          isConfigured={isConfigured}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          setIsForceRun={setIsForceRun}
          timeUnit={timeUnit}
          setTimeUnit={setTimeUnit}
          timeValue={timeValue}
          setTimeValue={setTimeValue}
          schedulingMode={schedulingMode}
          setSchedulingMode={setSchedulingMode}
          schedules={schedules}
          setSchedules={setSchedules}
          nextRun={nextRun}
          setNextRun={setNextRun}
          loading={loading}
          isServiceActive={isServiceActive}
          setIsServiceActive={setIsServiceActive}
        />
        <form noValidate style={{ minWidth: '100%' }}>
          <input type="hidden" value="prayer" />
          <TabPane tabId="2">
            {activeTab === '2' && (
              <Card bg={'light'} text={'dak'} className="mb-4">
                <CardBody>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        <Label>
                          VMware API Credentials
                          <span style={{ color: '#bd472a' }}>*</span>
                        </Label>
                        {!isAddingCredentials ? (
                          <>
                            <div>
                              <ButtonIcon
                                onClick={() => setIsAddingCredentials(true)}
                                color="falcon-default"
                                size="sm"
                                icon="plus"
                                iconClassName="fs--2"
                              >
                                Set Credentials
                              </ButtonIcon>

                              {fields.secretId || isValidCredentials ? (
                                <>
                                  {'  '}
                                  <FontAwesomeIcon icon={'check'} style={{ color: 'green', marginLeft: '10px' }} />{' '}
                                  VMware Credentials Stored
                                  <Row form>
                                    <Col lg="12" className="mt-4 mb-2">
                                      <CardText>Choose Organizations and Collectors for {vendorLabel}</CardText>
                                      <Row>
                                        {organizations.map((o, idx) => {
                                          return (
                                            <Col key={o.value} lg="6" className="mb-2">
                                              <Card className="mb-2">
                                                <CardBody>
                                                  <p className="mb-1">Organization:</p>
                                                  <ul className="list-inline">
                                                    <li className="mb-4">
                                                      <input
                                                        type="checkbox"
                                                        onChange={e => handleOrgsChange(o, idx)}
                                                        checked={o.active === 1 ? true : false}
                                                      />
                                                      <span className="ml-2">{o.label}</span>
                                                      <div className="ml-4">
                                                        {' '}
                                                        <p className="mb-1 mt-2">Collectors:</p>
                                                        <ul className="list-inline mt-2">
                                                          {o.collectors.map((c, i) => {
                                                            return (
                                                              <li
                                                                key={o.value + c.value}
                                                                className="list-inline-item mr-4"
                                                              >
                                                                <input
                                                                  type="checkbox"
                                                                  onChange={e => handleCollectorsChange(o, idx, i)}
                                                                  disabled={o.active === 0 ? true : false}
                                                                  checked={c.active === 1 ? true : false}
                                                                />
                                                                <span className="ml-2">{c.label}</span>
                                                              </li>
                                                            );
                                                          })}
                                                        </ul>
                                                      </div>
                                                    </li>
                                                  </ul>
                                                </CardBody>
                                              </Card>
                                            </Col>
                                          );
                                        })}
                                      </Row>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  id="username"
                                  autoComplete="new-password"
                                  onChange={handleFieldChange}
                                  value={fields.username}
                                  label={'VMware Username'}
                                  showFeedback={!fields.username && isSubmitted}
                                  feedback={'Please specify username.'}
                                  placeholder="Enter VMware username"
                                  style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                              <Col lg="6">
                                <FieldGroup
                                  type="password"
                                  id="password"
                                  label={'VMware Password'}
                                  autoComplete="new-password"
                                  placeholder="Enter VMware Password"
                                  onChange={handleFieldChange}
                                  value={fields.password}
                                  showFeedback={!fields.password && isSubmitted}
                                  feedback={'Please specify a password.'}
                                  required
                                />
                              </Col>
                            </Row>
                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={vendorId}
                            />
                            <ButtonIcon
                              onClick={() => setIsAddingCredentials(false)}
                              color="falcon-default"
                              size="sm"
                              icon="times"
                              iconclassname="fs--2"
                              style={{ marginRight: '10px' }}
                            >
                              Cancel
                            </ButtonIcon>
                          </>
                        )}
                        <FormFeedback
                          className={
                            !fields.secretId && !fields.username && !fields.password && isSubmitted ? 'd-block' : ''
                          }
                          type="invalid"
                        >
                          Please specify credentials.
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
          </TabPane>
          <DefaultConfigTab
            vendor={vendor}
            activeTab={activeTab}
            vendorLabel={vendorLabel}
            bugsDateBack={bugsDateBack}
            setBugsDateBack={setBugsDateBack}
            isSubmitted={isSubmitted}
            snCompanySysIdErrors={snCompanySysIdErrors}
            snCompanySysIdOptions={snCompanySysIdOptions}
            setSnCompanySysId={setSnCompanySysId}
            snCompanySysId={snCompanySysId}
            fields={fields}
            handleFieldChange={handleFieldChange}
          />

          <TabPane tabId="4">
            {activeTab === '4' && (
              <ProductPriority
                title="Default Bug Configuration"
                vendorPriorityOptions={vendorPriorityOptions}
                vendorStatusOptions={vendorStatusOptions}
                vendorBugCategoryOptions={vendorBugCategoryOptions}
                vendorBugTypeOptions={vendorBugTypeOptions}
                setVendorBugCategories={setVendorBugCategories}
                vendorBugCategories={vendorBugCategories}
                setVendorBugTypes={setVendorBugTypes}
                vendorBugTypes={vendorBugTypes}
                setVendorStatuses={setVendorStatuses}
                vendorStatuses={vendorStatuses}
                isSubmitted={isSubmitted}
                priorityMaps={priorityMaps}
                setPriorityMaps={setPriorityMaps}
                snPriorityOptions={snPriorityOptions}
                keywords={keywords}
                setKeywords={setKeywords}
                searchFields={searchFields}
                setSearchFields={setSearchFields}
                isCve={isCve}
                setIsCve={setIsCve}
                vendorRiskCategoryOptions={vendorRiskCategoryOptions}
                vendorRiskCategories={vendorRiskCategories}
                setVendorRiskCategories={setVendorRiskCategories}
              />
            )}
          </TabPane>
          <div style={{ minWidth: '100%' }}>
            <TabPane tabId="5">
              {activeTab === '5' && <RiskScore bugRisk={bugRisk} setBugRisk={setBugRisk} riskError={riskError} />}
            </TabPane>
          </div>
          <TabPane tabId="6">{activeTab === '6' && <ExecutionStatsTab vendorId={vendorId} />}</TabPane>
          <TabPane tabId="8">{activeTab === '8' && <AITab vendorId={vendorId} />}</TabPane>

          <Row className={`${activeTab === '1' ? 'd-none' : ''} flex-between-center`}>
            <Col xs="auto">
              <Button
                block
                color="falcon-danger"
                onClick={() => {
                  console.log(`/vendors/${vendorId}/configuration`);
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="auto">
              <SummaryModal
                modalOpen={modalOpen}
                isReadOnly={isReadOnly}
                setModalOpen={setModalOpen}
                handleSave={handleSave}
                isLoading={isLoading}
                vendorLabel={vendorLabel?.replace('Systems', 'Networks')}
                vendorId={vendorId}
                validated={validated}
                setValidated={setValidated}
                syncOnly={syncOnly}
                setSyncOnly={setSyncOnly}
                handleValidationError={handleValidationError}
              />
            </Col>
          </Row>
        </form>
      </TabContent>
    </>
  );
};
ConfigFormVmware.propTypes = {
  vendor: PropTypes.object,
  isReadOnly: PropTypes.bool,
  settings: PropTypes.object,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorResolutionOptions: PropTypes.array,
  snIntegrationCheck: PropTypes.bool,
  services: PropTypes.array,
  vendors: PropTypes.array,
  bugs: PropTypes.object,
  priorityStats: PropTypes.object,
  setPriorityStats: PropTypes.func,
  bugOptions: PropTypes.array,
  selectedBugOption: PropTypes.object,
  setSelectedBugOption: PropTypes.func,
  snCompanySysIdOptions: PropTypes.object,
  snCompanySysId: PropTypes.object,
  snCompanySysIdErrors: PropTypes.bool,
  vendorBugTypeOptions: PropTypes.array,
  vendorBugCategoryOptions: PropTypes.array,
  vendorEventScopes: PropTypes.array,
  setVendorEventScopes: PropTypes.func,
  vendorResolutions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  setVendorStatuses: PropTypes.func,
  vendorStatuses: PropTypes.array,
  fields: PropTypes.object,
  handleFieldChange: PropTypes.func,
  priorityMaps: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  snPriorityOptions: PropTypes.array,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  setSnCompanySysId: PropTypes.func,
  organizations: PropTypes.array,
  setOrganizations: PropTypes.func,
  vendorBugTypes: PropTypes.array,
  setVendorBugTypes: PropTypes.func,
  vendorBugCategories: PropTypes.array,
  setVendorBugCategories: PropTypes.func,
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  setServices: PropTypes.func,
  setVendors: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setBugs: PropTypes.func,
  isConfigured: PropTypes.bool,
  organizationOptions: PropTypes.array,
  setOrganizationOptions: PropTypes.func,
  isCve: PropTypes.bool,
  setIsCve: PropTypes.func,
  syncOnly: PropTypes.bool,
  setSyncOnly: PropTypes.func,
  bugRisk: PropTypes.array,
  setBugRisk: PropTypes.func,
  setVendorRiskCategories: PropTypes.func,
  vendorRiskCategories: PropTypes.array,
  vendorRiskCategoryOptions: PropTypes.array,
  loading: PropTypes.bool,
  setIsServiceActive: PropTypes.func,
  isServiceActive: PropTypes.number,
  allRequired: PropTypes.bool,
  isUpdated: PropTypes.bool,
  setAllRequired: PropTypes.func,
  setIsUpdated: PropTypes.func
};
export default ConfigFormVmware;
